// handshake-token.interface.ts

import { HandshakeMode, SurveyLoginType } from "./survey-resolver.interface";

export interface HandshakeTokenPayload {
  /** The internal Database ID of the survey */
  surveyId: number;

  /** How the user is entering (session, invitation, or self_serve) */
  loginType: SurveyLoginType;

  /** * If a session was found (via Cookie or Access Key), 
   * this is the UUID to resume. If null, /start creates a new one. 
   */
  sessionId: string | null;

  /** If loginType is 'invitation', this is the GUID to be "burned" on start */
  invitationId?: string;

  /** * The original query params and body params (lang, source, etc.) 
   * to be persisted into the new session metadata.
   */
  params: Record<string, any>;

  /** Issued At timestamp */
  iat?: number;

  /** Expiration timestamp (usually 5m from iat) */
  exp?: number;
}

export interface HandshakeResponse {
  mode: HandshakeMode;
  
  /** Only present if mode is 'authorized' or 'restart' */
  handshakeToken?: string;

  /** Only present if mode is 'needs_login' */
  consentMessage?: string;
  
  /** Server timestamp for sync/timeout logic */
  serverTime: number;
}